module.exports = __webpack_public_path__ + "zilla-slab-latin-500.f0adc7a079ca1ea55cd18d39080c315d.woff";